import { CopyMetadataFromParent, Property } from '@skylab-shared/core';
import { DocumentItemModel } from '../document/document-item.model';

@CopyMetadataFromParent()
export class InventoryDocumentItemModel extends DocumentItemModel {
    @Property({ nullable: true })
    public inventoryUnitCost?: number;

    @Property({ nullable: true })
    public inventoryTotalCost?: number;

    @Property()
    public relatedCommercialItemsIds: number[];

    @Property(Number,{nullable: true})
    public adjustedItemId: number | null;

    @Property()
    public uniqueKey: string;
}
